// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__Q4Vyz","range":"MonthRangeSwitch_range__2DHzf","disabled":"MonthRangeSwitch_disabled__B07xv"};